import React from 'react';

export const EXPENSE_CATEGORIES = [
  'Utilities', 'Raw Materials', 'Green Bean Purchase', 'Supplies', 'Rent & Facilities',
  'Equipment & Maintenance', 'Labor & Salaries', 'Marketing & Sales',
  'Transportation & Delivery', 'Professional Services', 'Other',
];

const inputCls = 'w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent';

export const AddExpenseModal = ({ formData, setFormData, onSubmit, onClose }) => (
  <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
    <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
      <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center">
        <h2 className="text-2xl font-bold text-gray-800">Add New Expense</h2>
        <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-2xl" data-testid="close-add-expense-modal">×</button>
      </div>

      <form onSubmit={onSubmit} className="p-6 space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Expense ID *</label>
            <input type="text" required value={formData.expense_id}
              onChange={(e) => setFormData({ ...formData, expense_id: e.target.value })}
              className={inputCls} placeholder="EXP-2024-001" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Date *</label>
            <input type="date" required value={formData.date}
              onChange={(e) => setFormData({ ...formData, date: e.target.value })}
              className={inputCls} />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Vendor/Payee *</label>
            <input type="text" required value={formData.vendor_payee}
              onChange={(e) => setFormData({ ...formData, vendor_payee: e.target.value })}
              className={inputCls} placeholder="Supplier Name" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Category *</label>
            <select required value={formData.category}
              onChange={(e) => setFormData({ ...formData, category: e.target.value })}
              className={inputCls}>
              {EXPENSE_CATEGORIES.map(cat => <option key={cat} value={cat}>{cat}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Subcategory</label>
            <input type="text" value={formData.subcategory}
              onChange={(e) => setFormData({ ...formData, subcategory: e.target.value })}
              className={inputCls} placeholder="Electricity, Gas, etc." />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Amount (₹) *</label>
            <input type="number" step="0.01" required value={formData.amount}
              onChange={(e) => setFormData({ ...formData, amount: parseFloat(e.target.value) })}
              className={inputCls} />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Payment Mode *</label>
            <select required value={formData.payment_mode}
              onChange={(e) => setFormData({ ...formData, payment_mode: e.target.value })}
              className={inputCls}>
              <option value="Cash">Cash</option>
              <option value="UPI">UPI</option>
              <option value="Card">Card</option>
              <option value="Bank">Bank Transfer</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Reference Number</label>
            <input type="text" value={formData.ref_no}
              onChange={(e) => setFormData({ ...formData, ref_no: e.target.value })}
              className={inputCls} placeholder="Transaction ID / Invoice No" />
          </div>
          <div className="md:col-span-2">
            <label className="block text-sm font-medium text-gray-700 mb-2">Description *</label>
            <input type="text" required value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              className={inputCls} placeholder="Brief description of expense" />
          </div>
          <div className="md:col-span-2">
            <label className="block text-sm font-medium text-gray-700 mb-2">Notes</label>
            <textarea value={formData.notes}
              onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
              rows="3" className={inputCls} placeholder="Additional notes..." />
          </div>
        </div>

        <div className="flex justify-end space-x-4 pt-4 border-t border-gray-200">
          <button type="button" onClick={onClose}
            className="px-6 py-2 border border-gray-300 rounded-lg font-medium text-gray-700 hover:bg-gray-50 transition">
            Cancel
          </button>
          <button type="submit"
            className="px-6 py-2 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-lg font-semibold hover:from-green-600 hover:to-emerald-700 transition shadow-lg"
            data-testid="submit-expense-button">
            Add Expense
          </button>
        </div>
      </form>
    </div>
  </div>
);

export const EditExpenseModal = ({ formData, setFormData, onSubmit, onClose }) => (
  <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
    <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
      <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center">
        <h2 className="text-2xl font-bold text-gray-800">Edit Expense</h2>
        <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-2xl" data-testid="close-edit-expense-modal">×</button>
      </div>
      <form onSubmit={onSubmit} className="p-6 space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Expense ID</label>
            <input type="text" disabled value={formData.expense_id} className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-100 text-gray-600" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Vendor/Payee *</label>
            <input type="text" required value={formData.vendor_payee} onChange={(e) => setFormData({ ...formData, vendor_payee: e.target.value })} className={inputCls} />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Category *</label>
            <select required value={formData.category} onChange={(e) => setFormData({ ...formData, category: e.target.value })} className={inputCls}>
              {EXPENSE_CATEGORIES.map(cat => <option key={cat} value={cat}>{cat}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Amount *</label>
            <input type="number" step="0.01" required value={formData.amount} onChange={(e) => setFormData({ ...formData, amount: parseFloat(e.target.value) })} className={inputCls} />
          </div>
          <div className="md:col-span-2">
            <label className="block text-sm font-medium text-gray-700 mb-2">Description *</label>
            <textarea required value={formData.description} onChange={(e) => setFormData({ ...formData, description: e.target.value })} rows="3" className={inputCls} />
          </div>
        </div>
        <div className="flex justify-end space-x-4 pt-4 border-t border-gray-200">
          <button type="button" onClick={onClose} className="px-6 py-2 border border-gray-300 rounded-lg font-medium text-gray-700 hover:bg-gray-50 transition">Cancel</button>
          <button type="submit" className="px-6 py-2 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg font-semibold hover:from-blue-600 hover:to-blue-700 transition shadow-lg" data-testid="update-expense-button">Update Expense</button>
        </div>
      </form>
    </div>
  </div>
);
